<template>
  <dialog
    ref="dialog"
    class="dialog"
    @click="click($event)"
    :style="[modelValue ? 'z-index: 999;' : 'z-index: 0; visibility: hidden;']"
  >
    <div v-if="modelValue" class="dialog-box">
      <div class="close" @click="onDialogAction(false)"></div>
      <div class="dialog-action">
        <p>{{ message }}</p>
        <p v-if="subMessage">{{ subMessage }}</p>
        <Field
          type="text"
          v-model="url"
          name="url"
          :placeholder="setPlaceFolder()"
          class="text-field"
          tabindex="0"
          v-if="showTextField"
        />

        <common-button
          v-if="!loading && !showTextField"
          :data="{
            status: !loading ? 0 : 2,
            button: button,
          }"
          @click="!loading ? onDialogAction(true) : ''"
        ></common-button>
        <!--テキストフィールド表示あり-->
        <common-button
          v-if="!loading && showTextField"
          :data="{
            status: !loading && showTextField && url ? 0 : 2,
            button: button,
          }"
          @click="!loading && showTextField && url ? onDialogAction(true) : ''"
        ></common-button>
      </div>
    </div>
  </dialog>
  <div class="l-modal" v-if="modelValue">
    <div :class="[modelValue ? 'l-modal__bg' : '']"></div>
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from "vue";
import CommonButton from "./CommonButton.vue";
import { Field } from "vee-validate";

// APIを公開
defineExpose({
  openDialog,
});

export type DialogProps = {
  modelValue: boolean;
  message: string;
  button: string;
  subMessage?: string;
  showTextField?: boolean;
  placeFolder?: string;
  submitUrl?: string;
};

const url = ref("");
// dialogの参照を保持する変数
const dialog = ref<HTMLDialogElement | null>(null);
const loading = ref(false);
// const open = ref(false);
const emit = defineEmits(["apply", "update:modelValue"]);
const props = defineProps<DialogProps>();

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const click = async ($event: any) => {
  if (!$event || !$event.target) {
    // escapeボタンでは閉じないようにする
    emit("update:modelValue", false);
    dialog?.value?.close();
  }
};

// 外部に公開するAPI。ダイアログを開いて、終了
function openDialog() {
  dialog?.value?.showModal();
  url.value = props.submitUrl || "";
}

// ボタンが押されたときに呼ばれるコールバック
async function onDialogAction(action: boolean) {
  if (action) {
    loading.value = true;
    emit("apply", url.value);
    loading.value = false;
    dialog?.value?.close();
  } else {
    dialog?.value?.close();
  }
  emit("update:modelValue", false);
}

function setPlaceFolder() {
  return props.placeFolder || "";
}

watch<string | undefined>(
  () => props.submitUrl,
  (newValue) => {
    if (newValue) {
      url.value = newValue;
    }
  }
);
</script>
<style lang="scss" scoped>
@import "../assets/style/_variables.scss";
.dialog {
  position: relative;
  overflow: auto;
  text-align: center;
  display: inline-grid;
  align-items: center;
  width: 315px;
  height: 205px;
  position: relative;
  border-width: 0;
}
.l-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 999;
}
.l-modal__bg {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.75);
  position: fixed;
  top: 0;
  left: 0;
  text-align: center;
  > div {
    width: 100%;
    position: fixed;
    bottom: 64px;
    text-decoration-line: underline;
    color: $white;
    font-weight: 300;
    font-size: $FONT_SIZE_M;
  }
}
.dialog-action {
  text-align: center;
  p:nth-child(2) {
    font-style: normal;
    font-weight: 300;
    font-size: $FONT_SIZE_S;
    line-height: 150%;
    /* ボックスの高さと同一、または18px */
    align-items: center;
    text-align: center;
    white-space: pre-wrap;

    color: #000000;
  }

  p:nth-child(1) {
    font-style: normal;
    font-weight: 600;
    font-size: $FONT_SIZE_M;
    line-height: 150%;
    white-space: pre-wrap;
  }
}
.text-field {
  width: 248px;
  height: 48px;
  margin-bottom: 16px;
  padding: 0 0 0 8px;
  font-size: $FONT_SIZE_M;
}
.close {
  position: absolute;
  display: block;
  right: 0px;
  top: 0px;
  width: 9px;
  height: 9px;
  padding: 15px;
}
.close::before,
.close::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  width: 2px;
  height: 14px;
  background: #333;
}
.close::before {
  transform: translate(-50%, -50%) rotate(45deg);
}

.close::after {
  transform: translate(-50%, -50%) rotate(-45deg);
}
</style>
